
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/well-being",
      function () {
        return require("private-next-pages/well-being.tsx");
      }
    ]);
  